"use client";

import { createContext, useContext } from "react";

const PortalServerAuthContext = createContext(false);

export function PortalServerAuthProvider({ children }: { children: React.ReactNode }) {
  return <PortalServerAuthContext.Provider value>{children}</PortalServerAuthContext.Provider>;
}

export function usePortalServerAuth() {
  return useContext(PortalServerAuthContext);
}
